'use strict';

var React              = require('react'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    classnames = require('classnames');

var BUTTON_SHAPE = {
  class: React.PropTypes.string,
  text: React.PropTypes.string.isRequired,
  handler: React.PropTypes.func.isRequired,
};

var InfoPage = React.createClass({

  propTypes: {
    leftButton: React.PropTypes.shape(BUTTON_SHAPE),
    rightButton: React.PropTypes.shape(BUTTON_SHAPE)
  },

  getDefaultProps: function() {
    return {
      leftButton: null,
      rightButton: null
    };
  },

  _renderButton: function(side, options) {
    var classes = classnames({
      'htn-button': true,
      'htn-button--secondary': side === 'right'
    });

    return (
      <button
        className={classes}
        onTouchEnd={options.handler}
        onClick={options.handler}
        disabled={options.disabled === true}>
        {options.text}
      </button>
    );
  },

  render: function() {
    var leftButton = null;
    var rightButton = null;
    if (this.props.leftButton !== null) {
      leftButton = this._renderButton("left", this.props.leftButton);
    }
    if (this.props.rightButton !== null) {
      rightButton = this._renderButton("right", this.props.rightButton);
    }


    return (
      <div>
        <div className="info-text">
          {this.props.children}
        </div>
        <div className="info-buttons">
          {leftButton}
          {rightButton}
        </div>
      </div>
    );
  }
});

module.exports = InfoPage;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-infopage.jsx
 **/